var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noti-wrap"},[_c('notice-box',{attrs:{"is-convert-i18n":false,"notice-list":_vm.noticeList}}),_c('a',{staticClass:"noti-link-law",attrs:{"href":_vm.location,"target":"_blank"}},[_vm._v("내용 확인하기")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }